export class SearchParams {
  constructor(search) {
    this.search = search
  }

  asJson() {
    return {
      coverage: this.search.coverage,
      destination: this.search.destination,
      dropoff: this.search.dropoff,
      location_type: this.search.location_type,
      pickup: this.search.pickup,
      max_age: this.search.max_age,
      min_age: this.search.min_age,
      origin: this.search.origin,
      travel_mode: this.search.travel_mode
    }
  }
}
